import React, { memo, useCallback, useEffect, useState } from "react";
import { StyleSheet, View } from "react-native";
import Carousel from "react-native-looped-carousel";
import { isCLApp } from "../../config";
import { getAllGroupBuysv2 } from "../../services/api";
import AppText from "../AppText";
import useBannerCarouselContext, {
  BannerCarouselContextProvider,
} from "./BannerCarouselContext";
import GroupBuyItem from "./GroupBuyItem";

const GroupBuy = memo((props) => {
  const [groupBuys, setGroupBuys] = useState({});
  const { trackEvent } = props;
  const {
    cl_title = "",
    cx_title = "",
    items_width = 400,
    items_height = 300,
    list_items = [],
  } = groupBuys;

  const fetchGroupBuys = useCallback(async () => {
    try {
      const { data } = await getAllGroupBuysv2();
      setGroupBuys(data);
    } catch (e) {
      console.log(e);
    }
  }, []);

  useEffect(() => {
    fetchGroupBuys();
  }, []);

  const titleText = isCLApp ? cl_title : cx_title;

  return list_items.length >= 1 ? (
    <BannerCarouselContextProvider>
      <View>
        {typeof titleText === "string" && titleText.trim().length ? (
          <AppText bold fontType="head2" style={styles.listHeader}>
            {titleText}
          </AppText>
        ) : (
          <></>
        )}

        {Array.isArray(list_items) && list_items.length > 0 && (
          <View
            style={{
              position: "relative",
              marginVertical: 0,
              backgroundColor: "#F7F7F7",
            }}
          >
            <MainCarousel
              {...{
                list_items,
                items_height,
                items_width,
                trackEvent,
              }}
            />
          </View>
        )}
      </View>
    </BannerCarouselContextProvider>
  ) : (
    <></>
  );
});

const MainCarousel = ({
  list_items,
  items_height,
  items_width,
  trackEvent,
}) => {
  const [value] = useBannerCarouselContext();
  return (
    <Carousel
      bullets={true}
      bulletStyle={{
        height: 5,
        width: 5,
        backgroundColor: "rgba(255,255,255, 0.6)",
        borderRadius: 50,
        marginHorizontal: 3,
        borderWidth: 0,
      }}
      chosenBulletStyle={{
        height: 5,
        width: 8,
        backgroundColor: "#E40046",
        marginHorizontal: 3,
      }}
      bulletsContainerStyle={{
        flexDirection: "row",
        justifyContent: "center",
        alignItems: "center",
        position: "absolute",
        width: "100%",
        top: value.height / 1.45,
      }}
      style={{
        width: "100%",
        height: value.height,
      }}
      autoplay={false}
      pageInfo={false}
    >
      {Array.isArray(list_items) &&
        list_items.length &&
        list_items.map((item, i) => (
          <GroupBuyItem
            key={item.gb_id}
            id={i}
            trackEvent={trackEvent}
            {...item}
            {...{ items_width, items_height }}
          />
        ))}
    </Carousel>
  );
};

const styles = StyleSheet.create({
  listHeader: {
    paddingHorizontal: 15,
    paddingTop: 25,
    paddingBottom: 10,
  },
});

export default GroupBuy;
